import { render, staticRenderFns } from "./PromotionSubsetTaxonomy.vue?vue&type=template&id=610bc0b3&"
import script from "./PromotionSubsetTaxonomy.vue?vue&type=script&lang=ts&"
export * from "./PromotionSubsetTaxonomy.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports